import * as ActionTypes from '../../actions/CartActions';
import root from 'window-or-global';

const initialCartItems = [];
const mapOffer = offer => ({
  ...offer,
  image: offer.image || `${root.STATIC_URL}assets/images/no-image.png`,
});

const outOfStockItems = (state = initialCartItems, action) => {
  switch (action.type) {
    case ActionTypes.HANDLE_FETCH_CART_SUCCESS:
    case ActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_SUCCESS:
    case ActionTypes.HANDLE_EDIT_CART_ITEM_QUANTITY_SUCCESS:
    case ActionTypes.HANDLE_SUBMIT_CART_SUCCESS:
    case ActionTypes.HANDLE_ADD_TO_CART_SUCCESS:
      try {
        const { offers } = action.response.faultyCart;
        return offers.map(mapOffer);
      } catch (e) {
        return initialCartItems;
      }

    case ActionTypes.HANDLE_EDIT_CART_ITEM_QUANTITY_FAILURE:
    case ActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_FAILURE:
    case ActionTypes.HANDLE_SUBMIT_CART_FAILURE: {
      const { errors: { faultyCart } } = action;
      if (!faultyCart) {
        return initialCartItems;
      }

      return faultyCart.offers.map(mapOffer);
    }

    case ActionTypes.HANDLE_CHECKOUT_CART_FAILURE:
      const { errors: { faultyCart, isCartInvalid } } = action;
      if (!isCartInvalid) {
        return state;
      }
      if (!faultyCart) {
        return initialCartItems;
      }
      // is moving to cart tab, then update the faulty cart with updated response
      return faultyCart.offers.map(mapOffer);

    case ActionTypes.HANDLE_CLEAR_FAULTY_CART_SUCCESS: {
      return initialCartItems;
    }

    default:
      return state;
  }
};

export default outOfStockItems;

export const getCartItems = state => state;



// WEBPACK FOOTER //
// ./src/cart/reducers/outOfStockItems/index.js